module.exports = __webpack_public_path__ + "img/hackathons.826ad7d1.png";